import React, { useState, EventHandler } from 'react'
import { DropdownMenu } from '@paypalcorp/pp-react'
import SearchableTable from './SearchableTable'

const initialValue = [
  {
    primaryText: 'Visa, Mastercard, Discover, American Express',
    value: 'vmda',
  },
  { primaryText: 'Maestro', value: 'maestro' },
]

const ErrorCodesDropDown = () => {
  const [selectedValue, setSelectedValue] = useState(initialValue[0].value)

  const handleOnChange: EventHandler<any> = (event: any) => {
    setSelectedValue(event.target.value)
  }

  const handleOnClose: EventHandler<any> = (event: any) => {
    console.log(event)
  }

  return (
    <div data-testid="error-code-dropdown">
      <DropdownMenu
        id="error-code-dropdown"
        label="Select card type"
        options={initialValue}
        value={selectedValue}
        onChange={handleOnChange}
        onClose={handleOnClose}
      />
      {selectedValue === 'vmda' && (
        <div>
          <h3>AVS Error</h3>
          <SearchableTable
            rowDataName="non_maestro_avs_error"
            colDataName="avs_error"
            searchKeys={['meaning.value', 'matchedDetails.value']}
            searchable={true}
          />

          <h3>CVV Error</h3>
          <SearchableTable
            rowDataName="non_maestro_cvv_error"
            colDataName="cvv_error"
            searchable={false}
          />
        </div>
      )}

      {selectedValue === 'maestro' && (
        <div>
          <h3>AVS Error</h3>
          <SearchableTable
            rowDataName="maestro_avs_error"
            colDataName="avs_error"
            searchable={false}
          />

          <h3>CVV Error</h3>
          <SearchableTable
            rowDataName="maestro_cvv_error"
            colDataName="cvv_error"
            searchable={false}
          />
        </div>
      )}
    </div>
  )
}

export default ErrorCodesDropDown
